import React from 'react'
import { HoldingTypeEnum } from '../../../models/enum/holding-type.enum'
import JointTenancyCard from '../conveyancing/joint-tenancy-card'
import { ApplicationStep3 } from '../../../models/classes/ApplicationStep3.class';
import TenancyInCommonCard from '../conveyancing/tenancy-in-common-card';


interface HoldingTypeSegmentProps{
  holding_type:HoldingTypeEnum | undefined;
  ConveyancingSetFormValue:(value:any)=>void;
  ConveyancingValue:ApplicationStep3;
  ConveyancingErrors:any;
  forceError?: boolean;
}

function HoldingTypeSegment({...props}:HoldingTypeSegmentProps) {
  return (

    <>
      {props.holding_type === HoldingTypeEnum.joint_tenancy && <JointTenancyCard ConveyancingSetFormValue={props.ConveyancingSetFormValue} ConveyancingValue={props.ConveyancingValue}/>}
      {props.holding_type === HoldingTypeEnum.tenancy_in_common && <TenancyInCommonCard forceError={props.forceError} ConveyancingSetFormValue={props.ConveyancingSetFormValue} ConveyancingValue={props.ConveyancingValue} ConveyancingErrors={props.ConveyancingErrors}/>}
    </>
    
  )
}

export default HoldingTypeSegment
